/**
 * Reading a submitted form.
 *
 * `FormData.get` answers `string | File | null`, and every form in this app is
 * text only, so one helper turns that into the `string` the callers want — and
 * one test pins all three cases, instead of each form carrying its own branch.
 */

/** The value of text field `name`, or `''` when the form has no such field. */
export function formValue(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value : '';
}
